
import { defineComponent } from "vue";
import { BaseLayoutFooter } from "@/components/Common";

export default defineComponent({
  components: {
    BaseLayoutFooter,
  },
  setup() {
    const showFooterMenu = true;
    return {
      showFooterMenu
    };
  },
});
